// Types

import { OnChangeArgTypes } from '@components/ssap/SsapTypes';

interface FieldChangeArgs {
    disabled?: boolean,
    fields: string[],
    indexInArray: any,
    name: string,
    newData: OnChangeArgTypes[0],
    text?: string,
    value: any
}

/**
 * UniversalInput reports changes through a positional tuple:
 * (newData, indexInArray, fields, [ name, value, disabled, text ]).
 * Handlers receive it as rest args, so this maps the tuple onto named
 * properties and tolerates callers that omit the trailing entry.
 */
export const parseFieldChangeArgs = (args: any[]): FieldChangeArgs => {
    const [ newData, indexInArray, fields, fieldEntry ] = args;
    const [ name, value, disabled, text ] = fieldEntry ?? [];

    return { disabled, fields, indexInArray, name, newData, text, value };
};
